import './abstract_section_view.coffee';# Added by Script 
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.TopTagsComparison extends Monitoring.Reports.Executive.AbstractSectionView
  id: 'tags_comparison'
  tagName: 'section'
  template: JST["backbone/templates/monitoring/reports/executive/top_tags_comparison"]
  legendsTemplate: JST["backbone/templates/monitoring/reports/executive/hierarchy_legends"]

  initialize: (@options = {}) ->
    @colors = {}
    @colors[@options.settings.accountLabel.codes[0]] = @options.settings.accountLabel.color
    $.each @options.settings.competitorsLabels, (index, label) =>
      @colors[label.codes[0]] = label.color
    @companies = []
    @companies[0] = @options.settings.accountLabel.description.toLowerCase().replace(/\s/g, '-')
    $.each @options.settings.competitorsLabels, (index, competitor) =>
      @companies[index + 1] = competitor.description.toLowerCase().replace(/\s/g, '-')


  render: ->
    @$el.html(@template(companies: @companies))
    @bindChartsReady(1)
    @addHierarchy(@options.settings.accountLabel)
    competitors = @options.settings.competitorsLabels
    _.each(competitors, (competitor) =>
        @addHierarchy(competitor)
    )
    return this

  addHierarchy: (company) ->
    company_id = company.description.toLowerCase().replace(/\s/g, '-')
    query = @extendedQuery({labels: company.codes})
    divId = "#brand-hierarchy-#{company_id}"
    legendId = "#brand-hierarchy-legend-#{company_id}"
    callback = (response, div_id) =>
      response.levels[0] = _.sortBy(response.levels[0], (obj) -> -obj.y)
      @addLabels(response, legendId)
    options = { size: '100px', reducedRange: true, callback: callback, drillDownFunction: (clickEvent) ->
      {
        tags_node_name: [clickEvent.point.name]
        labels: [company.codes]
      }
    }
    @_addTagsPie(query, divId, options)
